import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "react-bootstrap";

export default function IPRangeRestrictionTable({ items, onEdit, onDelete }) {
    const columns = [
        { dataField: "description", text: "Descripción" },
        { dataField: "cidrBlock", text: "CIDR" },
        { dataField: "userId", text: "Id Usuario"},
        { dataField: "scope", text: "Scope" },
        {
            dataField: "isBlocked",
            text: "Bloqueado",
            formatter: (cell) => (cell ? "Sí" : "No")
        },
        {
            dataField: "actions",
            text: "Acciones",
            formatter: (_, row) => (
                <>
                    <Button variant="warning" size="sm" onClick={() => onEdit(row)}>✏️</Button>{' '}
                    <Button variant="danger" size="sm" onClick={() => onDelete(row.id)}>❌</Button>
                </>
            )
        }
    ];

    return <BootstrapTable keyField="id" data={items} columns={columns} bootstrap4 striped hover />;
}